<template>
  <div class="pagina-step">
    <div id="cofinanciamento-relatorio">
      <div
        class="floating-buttons"
        @mouseenter="showSidebarMenu = true"
        @mouseleave="showSidebarMenu = false"
      >
        <i class="icofont-navigation-menu menu-btn"></i>
        <ul v-show="showSidebarMenu">
          <li @click="voltar">
            <i class="icofont-arrow-left"></i> <span>Voltar</span>
          </li>
          <li @click="showModal = true">
            <i class="icofont-copy-invert"></i>
            <span> Ajude-nos a melhorar esse material</span>
          </li>
          <li @click="imprimirPagina()">
            <i class="icofont-print"></i> <span>Imprimir</span>
          </li>
        </ul>
      </div>

      <!-- Page 1 -->
      <div class="page">
        <div class="header-1">
          <h2 class="header-title-1">MUNICÍPIO DE {{ nomeMunicipio }}</h2>
          <h2 class="header-title-2">
            OPORTUNIDADES PARA A OTIMIZAÇÃO DE REPASSES NO COFINANCIAMENTO
            FEDERAL DA APS
          </h2>

          <p>
            Este relatório tem por objetivo apresentar as oportunidades para o
            município de <b>{{ nomeMunicipio }}</b
            >, maximizar o recebimento dos recursos do cofinanciamento federal
            da Atenção Primária à Saúde (APS), conforme define a
            <b>Portaria n° 3.493</b> de 10 de abril de 2024 e suas alterações
            (Portaria GM/MS n° 7.799, de 20 de agosto de 2025, e outras).
          </p>
        </div>

        <div class="substract">
          <h4>Resumo</h4>
          <p>
            No cofinanciamento federal da APS, o desempenho municipal das
            equipes interfere diretamente no valor mensal e anual que o
            município recebe. A projeção é de que o município possa receber ou
            deixar de receber até
            <b>
              R$
              {{
                resumoGanhoMensal.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })
              }}
            </b>
            no repasse mensal ou até
            <b>
              R$
              {{
                resumoGanhoAnual.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })
              }}
            </b>
            no repasse anual após o período de transição, especialmente a partir
            de setembro de 2026. Esse valor representa a diferença entre o
            desempenho <b>"ÓTIMO"</b>, que é o desejado, e o desempenho
            <b>"ATUAL"</b> que as equipes do município se encontram nos
            componentes de Qualidade e Vínculo e Acompanhamento Territorial
            (CVAT). A realização de Monitoramento e Avaliação (M & A) na APS
            torna-se indispensável para fazer busca ativa das pessoas e realizar
            monitoramento e avaliação dos indicadores. Com a realização de M & A
            na APS, é possível melhorar a assistência às pessoas e
            consequentemente os resultados dos indicadores e a classificação das
            equipes.
          </p>
        </div>

        <div class="content-text">
          <h2 class="title-2 text-left">1 INTRODUÇÃO</h2>
          <p>
            O cofinanciamento federal da APS definido pela
            <b>Portaria n° 3493</b> de 10 de abril de 2024 se apresenta como uma
            atualização do Previne Brasil que ficou vigente até abril de 2024. O
            cofinanciamento federal da APS é composto por 6 (seis) componentes:
          </p>
          <ol start="1" class="roman-list">
            <li>
              I. Componente Equidade:
              <ul>
                <li>
                  Valor fixo mensal para manutenção ou custeio das equipes de
                  eSF e eAP homologadas e válidas; e
                </li>
                <li>
                  Recurso de implantação em parcela única para novas equipes
                  eSF, eAP, eSB, eMulti, eSFR, eCR e eAPP homologadas.
                </li>
              </ul>
            </li>
            <li>
              II. Componente Vínculo e Acompanhamento Territorial (CVAT) para
              eSF, eAP e eSFR homologadas e válidas;
            </li>
            <li>
              III. Componente de Qualidade para eSF, eAP, eSB, eMulti, eSFR, eCR
              e eAPP homologadas e válidas;
            </li>
            <li>
              IV. Implantação e manutenção de programas, serviços, profissionais
              e outras composições de equipes que atuam na APS;
            </li>
            <li>V. Atenção à Saúde Bucal; e</li>
            <li>
              VI. Per capita de base populacional para ações no âmbito da APS.
            </li>
          </ol>

          <p>
            O município realiza <b>adesões</b> tanto no componente de
            <b>Atenção à Saúde Bucal</b>, quanto no componente de
            <b
              >implantação e manutenção de programas, serviços, profissionais e
              outras equipes que atuam na APS</b
            >. Nos demais componentes, não há adesão, porém é necessário atender
            aos requisitos estabelecidos nas normativas vigentes dos seis
            componentes mencionados.
          </p>

          <p>
            Os municípios do Brasil foram estratificados segundo a Nota Técnica
            122/2024, e receberam no Indicador de Equidade e Dimensionamento
            <b>(IED)</b>, uma nota que varia de <b>1 a 4</b>, o qual considera o
            Índice de Vulnerabilidade Social (IVS) e o porte populacional. O
            número 1 é utilizado para classificar municípios mais vulneráveis,
            enquanto o número 4 representa municípios com menor vulnerabilidade.
            <b>{{ nomeMunicipio }}</b
            >, possui uma população de
            <b>{{ dados.etapa10.populacao }} pessoas</b>, estando inserida na
            <b>faixa</b> de municípios com
            <b>{{ portePopulacional }} habitantes</b> e possuindo a
            classificação <b>IED {{ ied }}</b
            >.
          </p>

          <!-- <p>
            O Quadro 1 faz um comparativo entre quanto
            {{ nomeMunicipio }} recebia no modelo anterior e quanto passa a
            receber no cofinanciamento federal da APS.
          </p> -->
        </div>
      </div>

      <!-- Page 2 -->
      <div class="page">
        <!-- <div class="container-table">
          <span
            >Quadro 1 – Comparativo entre o modelo anterior e o cofinanciamento
            federal atual da APS
          </span>
          <table>
            <thead>
              <tr>
                <th>MODELO ANTERIOR</th>
                <th>COFINANCIAMENTO FEDERAL APS</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Recebia R$ 0,00. Não tinha essa previsão.</td>
                <td v-html="fixo.implantacao"></td>
              </tr>
              <tr>
                <td>Recebia R$ 0,00. Não tinha essa previsão.</td>
                <td v-html="fixo.custeio"></td>
              </tr>
              <tr>
                <td>
                  Recebia <b> R$ {{ capitacao_ponderada }} </b> na Capitação
                  Ponderada.
                </td>
                <td v-html="vinculo_e_acompanhamento[1].text"></td>
              </tr>
              <tr>
                <td>
                  Recebia: <br />
                  - <b>R$ {{ previne_brasil.pagamentoDesempenho }}</b> no
                  Pagamento por Desempenho; <br />
                  - <b>R$ {{ previne_brasil.indicadoresSaudeBucal }}</b> pelos
                  indicadores de saúde bucal; <br />
                  - <b>R$ 0,00</b> pelos indicadores da eMulti
                </td>
                <td v-html="qualidade[1].text"></td>
              </tr>
              <tr>
                <td>
                  Recebia <b>R$ {{ previne_brasil.informatizaAps }}</b> no
                  Informatiza APS.
                </td>
                <td>
                  Passa a receber no aumento dos recursos do novo modelo de
                  financiamento e tem também o SUS DIGITAL, mas não tem um
                  recurso específico para a informatização.
                </td>
              </tr>
              <tr>
                <td>
                  Recebia
                  <b>R$ {{ previne_brasil.pagamentoCriterioPopulacional }}</b>
                  de incentivo financeiro com base em critério populacional.
                </td>
                <td>
                  Passa a receber <b> R$ {{ perCapita }} </b> no componente per
                  capita de base populacional para ações no âmbito da APS.
                </td>
              </tr>
              <tr>
                <td>
                  Incentivo para as ações estratégicas. Valores definidos em
                  regras próprias de cada um.
                </td>
                <td>
                  Componente para implantação e manutenção de programas,
                  serviços, profissionais e outras composições de equipes que
                  atuam na APS. Valores definidos em regras próprias de cada um.
                </td>
              </tr>
              <tr>
                <td>Ações estratégicas: Saúde Bucal.</td>
                <td>Componente para atenção a Saúde Bucal.</td>
              </tr>
            </tbody>
          </table>
          <span class="fonte">{{ fonte }} </span>
        </div> -->

        <div class="content-text">
          <p>
            Segundo o CONASEMS (2024), os recursos da capitação ponderada, Saúde
            na Hora e informatização APS foram utilizados para compor o valor
            dos componentes: equidade no que se refere ao custeio mensal e o
            CVAT.
          </p>

          <p>
            Este relatório apresenta os valores e cálculos, com base no
            desempenho municipal
            <strong>"ATUAL"</strong> das equipes e valor
            <b style="color: green">máximo</b> (quando o
            <b style="color: green">desempenho</b> de todas as equipes do
            município for <b style="color: green">"ÓTIMO"</b> nos componentes
            CVAT e de qualidade).
          </p>
        </div>
        <fixo :dados="dados" :fixo="fixo" :regras="regras.fixo" :fonte="fonte">
        </fixo>
        <vinculo-acompanhamento
          :dados="dados"
          :regras="regras.vinculo_e_acompanhamento"
          :fonte="fonte"
        ></vinculo-acompanhamento>
      </div>

      <!-- Page 3 -->
      <div class="page">
        <qualidade
          :dados="dados"
          :regras="regras.qualidade"
          :fonte="fonte"
        ></qualidade>

        <h2 class="title-2 text-left">
          5 Implantação e manutenção de programas, serviços, profissionais e
          outras equipes da APS.
        </h2>

        <div class="content-text">
          <p>
            Aqui, tem-se as mesmas regras das ações estratégicas definidas no
            modelo anterior. As regras individuais e próprias não mudaram e
            contemplará o custeio:
          </p>
          <ol start="1" class="roman-list">
            <li>I - Das equipes Multiprofissionais - eMulti;</li>
            <li>II - Das equipes de Consultório na Rua - eCR;</li>
            <li>III - Das Unidades Básicas de Saúde Fluvial - UBSF;</li>
            <li>IV - Das equipes de Saúde da Família Ribeirinha - eSFR;</li>
            <li>V - Das equipes de Atenção Primária Prisional - eAPP;</li>
            <li>
              VI - Para o ente federativo responsável pela gestão das ações de
              atenção integral à saúde dos adolescentes em situação de privação
              de liberdade;
            </li>
            <li>
              VII - Do incentivo aos municípios com equipes de saúde integradas
              a programas de residência uniprofissional ou multiprofissional na
              Atenção Primária à Saúde;
            </li>
            <li>VIII - Do Programa Saúde na Escola - PSE;</li>
            <li>
              IX - Do incentivo financeiro federal de custeio para implementação
              de ações de atividade física no âmbito da APS - IAF;
            </li>
            <li>X - Dos profissionais microscopistas;</li>
            <li>
              XI - Da Estratégia de Agentes Comunitários de Saúde - ACS; e
            </li>
            <li>
              XII - De outros programas, serviços, profissionais e composições
              de equipe que venham a ser instituídos por meio de ato normativo
              específico do Ministério da Saúde.
            </li>
          </ol>
        </div>

        <h2 class="title-2 text-left">6 Saúde Bucal</h2>

        <div class="content-text">
          <p>
            A Saúde Bucal ganhou um componente próprio. No tempo em que o
            cofinanciamento federal da APS foi instituído, observou-se um
            aumento de recursos e uma maior valorização da Estratégia de Saúde
            Bucal (ESB). O componente para Atenção à Saúde Bucal contempla o
            custeio:
          </p>
          <ol start="1" class="roman-list">
            <li>I - Das equipes de Saúde Bucal - eSB;</li>
            <li>II - Das Unidades Odontológicas Móveis - UOM;</li>
            <li>III - Dos Centros de Especialidades Odontológicas - CEO;</li>
            <li>
              IV - Dos Laboratórios Regionais de Prótese Dentária - LRPD; e
            </li>
            <li>V - Dos Serviços de Especialidades em Saúde Bucal - SESB.</li>
          </ol>
        </div>

        <h2 class="title-2 text-left">7 Per Capita</h2>

        <div class="content-text">
          <p>
            Esse componente per capita de base populacional continua como no
            Previne Brasil, sem mudanças no valor até o momento. Esse valor é
            recalculado e divulgado anualmente. Para 2026, a PORTARIA GM/MS nº
            10.254, DE 23 DE FEVEREIRO DE 2026, estabeleceu o valor de R$ 5,95
            (cinco reais e noventa e cinco centavos) por pessoa.
          </p>
        </div>
      </div>

      <!-- Page 4 -->
      <div class="page">
        <h2 class="title-2 text-left">8 Desempenho do município</h2>

        <div class="content-text">
          <p>
            Segundo a Portaria GM/MS n° 10.994, de 13 de maio de 2026, no
            período de transição (até dezembro de 2026), a classificação máxima
            é "BOM" no CVAT, sendo que as equipes que estiverem na classificação
            ÓTIMA, passarão a receber como tal a partir de setembro de 2026. No
            componente de qualidade, as equipes que estão na classificação
            ÓTIMA, passaram a receber como tal a partir de maio de 2026. As
            equipes que continuarem nas classificações REGULAR e SUFICIENTE, nos
            componentes de qualidade e CVAT, receberão na classificação BOM até
            dezembro de 2026.
          </p>

          <p>
            O desempenho municipal (qualidade, vínculo e acompanhamento) é
            medido com os conceitos qualitativos (<b
              >REGULAR, SUFICIENTE, BOM ou ÓTIMO</b
            >). Essa classificação define o valor total mensal e anual que o
            município recebe no cofinanciamento federal da APS.
          </p>
          <p>
            Durante o período de transição (até dezembro de 2026), o município
            de
            <b>{{ nomeMunicipio }}</b
            >, tem suas equipes automaticamente classificadas como <b>"BOM"</b>.
            Pode ser que em janeiro de 2027, tenha equipes com classificação
            <strong>"REGULAR"</strong> no CVAT ou no componente de qualidade. Se
            não iniciar desde já ações de busca ativa e monitoramento e
            avaliação voltadas a atender os requisitos estabelecidos no
            cofinanciamento federal da APS, a classificação
            <b>“REGULAR”</b> fará com que o município tenha recursos federais
            reduzidos nos repasses mensais para a APS.
          </p>
          <p>
            <i
              >Para garantir que o município não venha a perder recursos,
              recomenda-se iniciar ações de M & A na APS de acordo com as
              recomendações do cofinanciamento federal da APS.</i
            >
          </p>
          <p>
            Considerando que, de acordo com o desempenho municipal (qualidade,
            vínculo e acompanhamento), a classificação muda e isso impacta o
            valor recebido em cada mês e no ano. Apresenta-se na sequência, os
            cenários para serem analisados.
          </p>

          <div>
            <h2 class="title-3 text-left">8.1 Regular</h2>

            <p>
              Na hipótese do desempenho de todas as equipes serem
              <b>“REGULAR”</b>, o quadro 5 e o Gráfico 1 apresentam a simulação
              dos valores a serem repassados por componente
              <b>mensalmente (a cada mês</b>) ao município. Esse é o menor valor
              que o município pode receber no cofinanciamento da APS.
            </p>

            <div class="row align-items-center">
              <div class="col-lg-12">
                <span style="text-transform: uppercase; font-weight: bold"
                  >Quadro 5, Gráfico 1 – Valores e percentuais na hipótese de
                  desempenho “REGULAR”.</span
                >
              </div>
              <div class="col-lg-6">
                <tabela-descricao
                  :fixo="fixo"
                  :vinculoAcompanhamento="
                    vinculo_e_acompanhamento[3].valorTotal
                  "
                  :qualidade="qualidade[3].valorTotal"
                  :perCapita="perCapitaTotal"
                  :fonte="fonte"
                  :dados="dados"
                ></tabela-descricao>
              </div>
              <div class="col-lg-6">
                <!-- <span class="text-center d-block">Gráfico 1</span> -->
                <div class="grafico-tabela-revisao">
                  <apexchart
                    ref="chartPie"
                    type="pie"
                    width="360"
                    :options="chartPieOptions"
                    :series="chartPieSeriesRegular"
                  ></apexchart>
                </div>
              </div>
            </div>

            <p>
              É importante lembrar que, se o recurso estiver suspenso, esse
              valor pode ser ainda menor. Portanto, realizar o monitoramento e
              avaliação mensalmente, vai ajudar a atender aos requisitos
              estabelecidos e também evitar as suspensões de recursos federais
              para a APS municipal.
            </p>
          </div>

          <div class="mt-4">
            <h2 class="title-3 text-left">8.2 Suficiente</h2>

            <p>
              Na hipótese do desempenho de todas as equipes serem
              <b>“SUFICIENTE”</b>, o quadro 6 e o gráfico 2 apresentam simulação
              dos valores a serem repassados por componente
              <b>mensalmente (a cada mês)</b> ao município no cofinanciamento
              federal da APS.
            </p>

            <div class="row align-items-center">
              <div class="col-lg-12">
                <span style="text-transform: uppercase; font-weight: bold"
                  >Quadro 6, Gráfico 2 – Valores e percentuais na hipótese de
                  desempenho "SUFICIENTE".</span
                >
              </div>
              <div class="col-lg-6">
                <tabela-descricao
                  :fixo="fixo"
                  :vinculoAcompanhamento="
                    vinculo_e_acompanhamento[2].valorTotal
                  "
                  :qualidade="qualidade[2].valorTotal"
                  :perCapita="perCapitaTotal"
                  :fonte="fonte"
                  :dados="dados"
                  numeroQuadro="6"
                  classificacao="Suficiente"
                ></tabela-descricao>
              </div>
              <div class="col-lg-6">
                <!-- <span class="text-center d-block">Gráfico 2</span> -->
                <div class="grafico-tabela-revisao">
                  <apexchart
                    ref="chartPie"
                    type="pie"
                    width="360"
                    :options="chartPieOptions"
                    :series="chartPieSeriesSuficiente"
                  ></apexchart>
                </div>
              </div>
            </div>

            <p>
              A classificação <b>“SUFICIENTE”</b>, também pode fazer o município
              perder recursos federais para a APS.
            </p>
          </div>
        </div>
      </div>

      <!-- Page 5 -->
      <div class="page">
        <div>
          <h2 class="title-3 text-left">8.3 Bom</h2>

          <div class="content-text">
            <p>
              Na hipótese do desempenho de todas as equipes serem <b>“BOM”</b>,
              o quadro 7 e o gráfico 3 apresentam simulação dos valores a serem
              repassados por componente <b>mensalmente (a cada mês)</b> ao
              município no cofinanciamento federal da APS.
            </p>
          </div>

          <div class="row align-items-center">
            <div class="col-lg-12">
              <span style="text-transform: uppercase; font-weight: bold"
                >Quadro 7, Gráfico 3 – Valores e percentuais na hipótese de
                desempenho "BOM".</span
              >
            </div>
            <div class="col-lg-6">
              <tabela-descricao
                :fixo="fixo"
                :vinculoAcompanhamento="vinculo_e_acompanhamento[1].valorTotal"
                :qualidade="qualidade[1].valorTotal"
                :perCapita="perCapitaTotal"
                :fonte="fonte"
                :dados="dados"
                numeroQuadro="7"
                classificacao="Bom"
              ></tabela-descricao>
            </div>
            <div class="col-lg-6">
              <!-- <span class="text-center d-block">Gráfico 3</span> -->
              <div class="grafico-tabela-revisao">
                <apexchart
                  ref="chartPie"
                  type="pie"
                  width="360"
                  :options="chartPieOptions"
                  :series="chartPieSeriesBom"
                ></apexchart>
              </div>
            </div>
          </div>

          <div class="content-text">
            <p>
              Recomenda-se que as ações de gestores e profissionais de saúde da
              APS no território estejam alinhadas pelo objetivo de conseguir a
              classificação <b>“ÓTIMO”</b> que representa o máximo de desempenho
              conforme o novo modelo de cofinanciamento federal da APS.
            </p>
          </div>
        </div>
        <div class="mt-4">
          <h2 class="title-3 text-left">8.4 Ótimo</h2>

          <div class="content-text">
            <p>
              <i>
                Esse será o desempenho que todos, equipe gestora e profissionais
                de saúde da APS, devem perseguir como objetivo nos municípios.
              </i>
            </p>

            <p>
              O Quadro 8 e o Gráfico 4 apresentam simulação dos valores a serem
              repassados por <b>componente mensalmente (a cada mês)</b> ao
              município no cofinanciamento federal da APS, quando o desempenho
              for <b>“ÓTIMO”</b>.
            </p>

            <p>
              O objetivo do município é maximizar o recebimento dos recursos
              federais na Atenção Primária à Saúde (APS) e, com isso, garantir
              com qualidade a oferta das ações e serviços de saúde para a
              população em seu território.
            </p>
          </div>

          <div class="row align-items-center">
            <div class="col-lg-12">
              <span style="text-transform: uppercase; font-weight: bold"
                >Quadro 8, Gráfico 4 – Valores e percentuais na hipótese de
                desempenho "ÓTIMO".</span
              >
            </div>
            <div class="col-lg-6">
              <tabela-descricao
                :fixo="fixo"
                :vinculoAcompanhamento="vinculo_e_acompanhamento[0].valorTotal"
                :qualidade="qualidade[0].valorTotal"
                :perCapita="perCapitaTotal"
                :fonte="fonte"
                :dados="dados"
                numeroQuadro="8"
                classificacao="Ótimo"
              ></tabela-descricao>
            </div>
            <div class="col-lg-6">
              <!-- <span class="text-center d-block">Gráfico 4</span> -->
              <div class="grafico-tabela-revisao">
                <apexchart
                  ref="chartPie"
                  type="pie"
                  width="360"
                  :options="chartPieOptions"
                  :series="chartPieSeriesOtimo"
                ></apexchart>
              </div>
            </div>
          </div>

          <div class="content-text">
            <p>
              <i
                >"Não se gerencia o que não se mede, não se mede o que não se
                define e não se define o que não se entende, ou seja, não há
                sucesso no que não se monitora, avalia, intervém e gerencia"</i
              >, esta citação é, regularmente, atribuída ao estatístico William
              Edwards Deming e nos diz que é preciso conhecer, definir,
              monitorar, avaliar, enfim, gerenciar para ter sucesso.
            </p>
            <p>
              Complementando, CONASEMS (2024), ressalta a necessidade de
              realizar monitoramento e avaliação com ferramentas de informática
              confiáveis como forma de melhorar a assistência à população e
              consequentemente atender aos requisitos estabelecidos no novo
              modelo de cofinanciamento federal da APS.
            </p>
            <p>
              Portanto, o uso do monitoramento e avaliação integrado ao processo
              de trabalho dos profissionais de saúde em equipe atuando de forma
              estratégica da APS pode ajudar no objetivo de conseguir a
              classificação de desempenho
              <b>“ÓTIMO”</b> para as equipes e para o município.
            </p>
          </div>
        </div>
      </div>

      <!-- Page 6 -->
      <div class="page">
        <h2 class="title-3 text-left">8.5 Análise dos cenários</h2>

        <div class="content-text">
          <p>
            O Quadro 9 contém de forma consolidada
            <b>mensalmente (a cada mês)</b> uma comparação dos valores recebidos
            no modelo anterior e no cofinanciamento federal da APS. Nele,
            recomenda-se observar, especialmente se conforme o desempenho, o
            município tem aumento ou redução de repasses federais na APS.
            Valores negativos (com sinal de menos -) representam diminuição do
            valor em relação ao modelo de financiamento anterior.
          </p>

          <p v-html="textoTabelaPorcentagem"></p>

          <p>
            Portanto, para não perder recursos federais na APS, que pode
            acontecer se o desempenho for <b style="color: red">“REGULAR”</b>,
            <b style="color: red">“SUFICIENTE”</b> ou
            <b style="color: red">“BOM”</b>, faz-se necessário trabalhar para um
            desempenho <b style="color: green">“ÓTIMO”</b> em cada equipe e
            consequentemente a nível municipal.
          </p>

          <tabela-porcentagem
            :data="dadosTabelaPorcentagem"
            :fonte="fonte"
          ></tabela-porcentagem>

          <p v-html="texto2TabelaPorcentagem"></p>

          <div class="mt-4">
            <span style="text-transform: uppercase; font-weight: bold"
              >Gráfico 5 - Total mensal de recursos do cofinanciamento federal
              da APS por classificação
            </span>
            <div id="chart">
              <apexchart
                class="chartBar"
                ref="chartPorcentagem"
                type="bar"
                width="100%"
                height="350"
                :options="chartBarOptions"
                :series="chartSeriesTabelaPorcentagem"
              ></apexchart>
            </div>
            <span class="fonte d-block mb-3" v-html="fonte"></span>
          </div>

          <p v-html="texto3TabelaPorcentagem"></p>

          <div class="mt-4">
            <span style="text-transform: uppercase; font-weight: bold"
              >Gráfico 6 - Total anual de recursos do cofinanciamento federal da
              APS por classificação
            </span>
            <div id="chart">
              <apexchart
                class="chartBar"
                ref="chartPorcentagemAnual"
                type="bar"
                width="100%"
                height="350"
                :options="chartBarOptions"
                :series="chartSeriesTabelaPorcentagemAnual"
              ></apexchart>
            </div>
            <span class="fonte d-block mb-3" v-html="fonte"></span>
          </div>

          <p>
            Espera-se que essas informações sobre os 4 (quatro) possíveis
            cenários de desempenho e seu impacto nos repasses mensais e anuais
            de recursos federais para a APS de {{ nomeMunicipio }}, possam
            ajudar no planejamento das ações.
          </p>
        </div>
      </div>

      <!-- Page 7 -->
      <div class="page">
        <mais-medicos
          :dados="dados"
          :fixo="fixo"
          :vinculoAcompanhamento="vinculo_e_acompanhamento"
          :fonte="fonte"
          classificacao="Bom"
        ></mais-medicos>

        <saude-bucal
          :dados="dados"
          :fixo="fixo"
          :fonte="fonte"
          classificacao="Bom"
        ></saude-bucal>
      </div>

      <!-- Page 8 -->
      <div class="page">
        <emulti
          :dados="dados"
          :fixo="fixo"
          :fonte="fonte"
          classificacao="Bom"
        ></emulti>

        <div class="content-text">
          <h2 class="title-3 text-left">9.4 Per capita</h2>
          <p>
            Segundo a Portaria GM/MS 10.254, de 23 de fevereiro de 2026, o
            cálculo do valor mensal do incentivo financeiro com base em critério
            populacional foi realizado multiplicando-se o valor per capita
            anual, de que trata o caput, dividido por 12 (doze), utilizando os
            parâmetros da população dos municípios e do Distrito Federal de
            acordo com a estimativa populacional divulgada pelo Instituto
            Brasileiro de Geografia e Estatística - IBGE, em 01 de julho de
            2025, dividido por 12 (doze).
          </p>
          <p>No FNS, a ação detalhada pode ser:</p>
          <ul style="margin: 0 0 20px 60px">
            <li>
              1. “INCENTIVO FINANCEIRO DA APS - MANUTENÇÃO DE PAGAMENTO DE VALOR
              NOMINAL COM BASE EM EXERCÍCIO ANTERIOR”, porque o município teve
              decréscimo populacional e por isso ocorre a manutenção do valor
              nominal repassado no ano anterior; ou
            </li>
            <li>
              2. “INCENTIVO FINANCEIRO DA APS – COMPONENTE PER CAPITA DE BASE
              POPULACIONAL”, porque o município teve acréscimo populacional ou
              estabilidade populacional.
            </li>
          </ul>
          <p>
            Lembrando que esse valor no FNS pode estar acumulado por causa de
            atrasos no repasse.
          </p>
        </div>

        <conclusao
          :dados="dados"
          :nomeMunicipio="nomeMunicipio"
          :diferencaMensalOtimoRegular="diferencaMensalOtimoRegular"
          :diferencaAnualOtimoRegular="diferencaAnualOtimoRegular"
        ></conclusao>

        <div class="page-break"></div>
      </div>

      <!-- Page 9 -->
      <div class="page">
        <referencias></referencias>
      </div>
    </div>

    <b-modal
      id="formObservacao"
      v-model="showModal"
      title="Ajude-nos a melhorar esse material"
      centered
      scrollable
      hide-footer
    >
      <p class="my-4">
        <textarea
          name=""
          id=""
          class="form-control"
          rows="10"
          v-model="form.sugestao"
        ></textarea>
      </p>
      <button @click="salvarSugestao()">
        Salvar
        <b-spinner
          label="Spinning"
          small
          variant="white"
          v-if="loadingBtnSalvarSugestao"
        ></b-spinner>
      </button>
    </b-modal>
  </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { TheMask } from 'vue-the-mask'
import Masks from '@/mixins/masks'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
import TabelaDescricao from './components/TabelaDescricao.vue'
import TabelaPorcentagem from './components/TabelaPorcentagem.vue'
import Fixo from './components/Fixo.vue'
import VueApexCharts from 'vue-apexcharts'
import { regras, getLabelRegra } from './utils.js'
import VinculoAcompanhamento from './components/VinculoAcompanhamento.vue'
import Qualidade from './components/Qualidade.vue'
import MaisMedicos from './components/MaisMedicos.vue'
import SaudeBucal from './components/SaudeBucal.vue'
import Emulti from './components/Emulti.vue'
import Conclusao from './components/Conclusao.vue'
import Referencias from './components/Referencias.vue'

validations()

export default {
  components: {
    PulseLoader,
    'vue-select': VueSelect,
    ValidationObserver,
    ValidationProvider,
    TheMask,
    TabelaDescricao,
    TabelaPorcentagem,
    Fixo,
    apexchart: VueApexCharts,
    VinculoAcompanhamento,
    Qualidade,
    MaisMedicos,
    SaudeBucal,
    Emulti,
    Conclusao,
    Referencias,
  },
  props: {
    dados: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      capitacao_ponderada: 0,
      fixo: {
        implantacao: '',
        custeio: '',
        valorImplantacao: 0,
        valorCusteio: 0,
      },
      vinculo_e_acompanhamento: [
        {
          classificacao: 'Ótimo',
          text: '',
          valorTotal: 0,
        },
        {
          classificacao: 'Bom',
          text: '',
          valorTotal: 0,
        },
        {
          classificacao: 'Suficiente',
          text: '',
          valorTotal: 0,
        },
        {
          classificacao: 'Regular',
          text: '',
          valorTotal: 0,
        },
      ],
      qualidade: [
        {
          classificacao: 'Ótimo',
          text: '',
          valorTotal: 0,
        },
        {
          classificacao: 'Bom',
          text: '',
          valorTotal: 0,
        },
        {
          classificacao: 'Suficiente',
          text: '',
          valorTotal: 0,
        },
        {
          classificacao: 'Regular',
          text: '',
          valorTotal: 0,
        },
      ],
      previne_brasil: {
        capitacaoPonderada: 0,
        pagamentoDesempenho: 0,
        informatizaAps: 0,
        indicadoresSaudeBucal: 0,
        indicadoresSaudeNaHora: 0,
        pagamentoCriterioPopulacional: 0,
      },
      perCapita: 0,
      perCapitaTotal: 0,
      dadosTabelaPorcentagem: [],
      showModal: false,
      loadingBtnSalvarSugestao: false,
      form: {
        sugestao: '',
      },
      chartPieSeriesRegular: [],
      chartPieSeriesSuficiente: [],
      chartPieSeriesBom: [],
      chartPieSeriesOtimo: [],
      chartPieOptions: {
        chart: {
          width: 380,
          type: 'pie',
        },
        labels: [
          // 'Fixo Implantação',
          'Equidade',
          'Qualidade',
          'Vínculo e acompanhamento',
          'Per capita',
        ],
        colors: ['#156082', '#E97132', '#196B24', '#0F9ED5', '#A02B93'],
        legend: {
          position: 'bottom',
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 350,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
      },
      chartSeriesTabelaPorcentagem: [],
      chartSeriesTabelaPorcentagemAnual: [],
      chartBarOptions: {
        xaxis: {
          categories: ['Ótimo', 'Bom', 'Suficiente', 'Regular'],
        },
        yaxis: {
          labels: {
            formatter: (val) => {
              return (
                'R$ ' +
                val.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })
              )
            },
          },
        },
        colors: ['#22B14C', '#FFF200', '#FF7F27', '#ED1C24'],
        plotOptions: {
          bar: {
            columnWidth: '65%',
            distributed: true,
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return (
              'R$ ' +
              val.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
              })
            )
          },
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ['#304758'],
          },
        },
        legend: {
          show: false,
        },
      },
      regras: regras,
      textoTabelaPorcentagem: '',
      texto2TabelaPorcentagem: '',
      texto3TabelaPorcentagem: '',
      showSidebarMenu: false,
      diferencaMensalOtimoRegular: 0,
      diferencaAnualOtimoRegular: 0,
    }
  },
  mounted() {
    this.preencherRelatorio()
  },
  computed: {
    cidadeEstado() {
      return `${this.dados?.etapa1.cidade.no_municipio} - ${this.dados?.etapa1.estado.uf}`
    },

    maskMoney() {
      return Masks['money']
    },

    nomeMunicipio() {
      return (
        this.dados.etapa1.cidade.no_municipio +
        ' – ' +
        this.dados.etapa1.estado.uf
      )
    },

    portePopulacional() {
      const labelSplit = this.dados.etapa3.porte_populacional.label.split('-')
      return labelSplit[1].trim().toLowerCase()
    },

    ied() {
      return this.dados.etapa3.ied.value
    },

    fonte() {
      let dataAtual = new Date()

      let nomesMeses = [
        'janeiro',
        'fevereiro',
        'março',
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro',
      ]

      let mesAtual = nomesMeses[dataAtual.getMonth()]

      let anoAtual = dataAtual.getFullYear()

      let mesAnoFormatado = mesAtual + '/' + anoAtual
      return `<b>Fonte</b>: Autoria própria, ${mesAnoFormatado}`
    },

    resumoGanhoMensal() {
      return Number(this.dados?.etapa4?.totalPerda || 0)
    },

    resumoGanhoAnual() {
      return this.resumoGanhoMensal * 12
    },
  },
  methods: {
    /**
     * Retorna a quantidade da equipe conforme o label usado nas regras.
     *
     * @param {String} label
     * @returns {Number}
     */
    getQuantidadeEquipe(label) {
      const aliases = {
        'eSF 40h': 'eSF',
      }

      const labelEtapa4 = aliases[label] || label

      return Number(this.dados?.etapa4?.totaisEquipes?.[labelEtapa4] || 0)
    },

    preencherRelatorio() {
      const novasEquipes = this.dados?.etapa5?.equipes
      // componente fixo por implantação
      if (novasEquipes != null) {
        let somaComponenteFixoImplantacao = novasEquipes.reduce((acc, item) => {
          return acc + item.valor_implantacao * parseInt(item.value)
        }, 0)

        const quantEsf = novasEquipes.find((el) => el.key == 'esf')?.value
        const quantEAP30h = novasEquipes.find(
          (el) => el.key == 'eap_30h'
        )?.value
        const quantEAP20h = novasEquipes.find(
          (el) => el.key == 'eap_20h'
        )?.value
        const quantESB40h = novasEquipes.find(
          (el) => el.key == 'esb_40h'
        )?.value
        const quantEmultiAmpliada = novasEquipes.find(
          (el) => el.key == 'emulti_ampliada'
        )?.value
        const quantEmultiComplementar = novasEquipes.find(
          (el) => el.key == 'emulti_complementar'
        )?.value
        const quantEmultiEstrategica = novasEquipes.find(
          (el) => el.key == 'emulti_estrategica'
        )?.value
        this.fixo.implantacao = `
          Passa a receber <b>R$ ${somaComponenteFixoImplantacao.toLocaleString(
            'pt-BR',
            {
              minimumFractionDigits: 2,
            }
          )}</b> no componente fixo implantação em parcela única. Esse valor considera: <b>${quantEsf} eSF</b>, <b>${quantEAP30h} eAP 30h</b>, <b>${quantEAP20h} eAP 20h</b>, <b>${quantESB40h} eSB 40h</b>, <b>${quantEmultiAmpliada} eMulti ampliada</b>, <b>${quantEmultiComplementar} eMulti complementar</b> e <b>${quantEmultiEstrategica} eMulti estratégica</b> novas que foram implantadas.
        `
        this.fixo.valorImplantacao = somaComponenteFixoImplantacao
      } else {
        this.fixo.implantacao =
          'O município não tem equipes novas a serem consideradas no componente fixo de implantação.'
      }

      const equipesImplantadas = this.dados?.etapa4?.totaisEquipes || {}

      if (equipesImplantadas != null) {
        // componente fixo por custeio
        const ied = this.dados.etapa3.ied.value
        const valoresDasEquipesCusteio = this.regras.fixo.custeio.find(
          (item) => item.ied === ied
        )
        let somaComponenteCusteioImplantacao = 0
        valoresDasEquipesCusteio.tipos_equipes.forEach((element) => {
          const quantidadeDeEquipes = this.getQuantidadeEquipe(element.label)
          somaComponenteCusteioImplantacao +=
            element.valor * quantidadeDeEquipes
        })

        // (3 eSF x R$ 16.000) + (0 eAP 30h x R$ 9.600,00) + (0 eAP 20h x R$ 6.400,00) = R$ 48.000,00

        this.fixo.custeio = `
          Passa a receber <b>R$ ${somaComponenteCusteioImplantacao.toLocaleString(
            'pt-BR',
            {
              minimumFractionDigits: 2,
            }
          )}</b> no componente fixo de custeio. Esse valor considera: <b>${
          equipesImplantadas['eSF']
        } eSF</b>, <b>${equipesImplantadas['eAP 30h']} eAP 30h</b>, <b>${
          equipesImplantadas['eAP 20h']
        } eAP 20h</b>.
        `
        this.fixo.valorCusteio = somaComponenteCusteioImplantacao

        // componente de vínculo e acompanhamento
        for (
          let index = 0;
          index < this.vinculo_e_acompanhamento.length;
          index++
        ) {
          const element = this.vinculo_e_acompanhamento[index]
          let val = this.valoresComponenteVinculoAcompanhamento(
            element.classificacao
          )
          element.text = val.text
          element.valorTotal = val.total
        }

        // Componente de qualidade
        for (let index = 0; index < this.qualidade.length; index++) {
          const element = this.qualidade[index]
          let val = this.valoresComponenteQualidade(element.classificacao)
          element.text = val.text
          element.valorTotal = val.total
        }
      }

      //capitação ponderada
      this.capitacao_ponderada =
        this.dados.etapa6.capitacaoPonderada.toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
        })

      // pagamento por desempenho
      this.previne_brasil.pagamentoDesempenho =
        this.dados.etapa6.pagamentoDesempenho.toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
        })
      // indicadores saúde bucal
      this.previne_brasil.indicadoresSaudeBucal =
        this.dados.etapa6.indicadoresSaudeBucal.toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
        })

      // informatiza aps
      this.previne_brasil.informatizaAps =
        this.dados.etapa6.informatizaAps.toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
        })

      // pagamento critério populacional
      this.previne_brasil.pagamentoCriterioPopulacional =
        this.dados.etapa6.pagamentoCriterioPopulacional.toLocaleString(
          'pt-BR',
          {
            minimumFractionDigits: 2,
          }
        )
      // per capita
      // this.perCapita =
      //   this.previne_brasil.pagamentoCriterioPopulacional.toLocaleString(
      //     'pt-BR',
      //     {
      //       minimumFractionDigits: 2,
      //     }
      //   )
      this.perCapitaTotal = this.dados.etapa11.per_capita

      // Dados gráfico Regular
      this.chartPieSeriesRegular = [
        // this.fixo.valorImplantacao,
        this.fixo.valorCusteio,
        this.qualidade[3].valorTotal,
        this.vinculo_e_acompanhamento[3].valorTotal,
        this.perCapitaTotal,
      ]

      // Dados gráfico Suficiente
      this.chartPieSeriesSuficiente = [
        // this.fixo.valorImplantacao,
        this.fixo.valorCusteio,
        this.qualidade[2].valorTotal,
        this.vinculo_e_acompanhamento[2].valorTotal,
        this.perCapitaTotal,
      ]

      // Dados gráfico Bom
      this.chartPieSeriesBom = [
        // this.fixo.valorImplantacao,
        this.fixo.valorCusteio,
        this.qualidade[1].valorTotal,
        this.vinculo_e_acompanhamento[1].valorTotal,
        this.perCapitaTotal,
      ]

      // Dados gráfico Ótimo
      this.chartPieSeriesOtimo = [
        // this.fixo.valorImplantacao,
        this.fixo.valorCusteio,
        this.qualidade[0].valorTotal,
        this.vinculo_e_acompanhamento[0].valorTotal,
        this.perCapitaTotal,
      ]

      this.formatarDadosDaTabelaPorcentagem()
    },

    /**
     * Calcula os valores do componente vínculo e acompanhamento
     * conforme a classificação informada.
     *
     * @param {String} classificacao
     * @returns {Object}
     */
    valoresComponenteVinculoAcompanhamento(classificacao) {
      const equipes = this.dados?.etapa4?.equipes || []
      let total = 0

      equipes
        .filter((item) => item.componente === 'CVAT')
        .forEach((item) => {
          const regra = this.regras.vinculo_e_acompanhamento.find((regra) => {
            return regra.label === getLabelRegra(item.equipe)
          })

          if (!regra) return

          const classificacaoEquipe = regra.classificacao.find((el) => {
            return el.tipo === classificacao
          })

          if (!classificacaoEquipe) return

          total += Number(item.quantidade || 0) * classificacaoEquipe.valor
        })

      return {
        text: '',
        total,
      }
    },

    /**
     * Calcula os valores do componente qualidade
     * conforme a classificação informada.
     *
     * @param {String} classificacao
     * @returns {Object}
     */
    valoresComponenteQualidade(classificacao) {
      const equipes = this.dados?.etapa4?.equipes || []
      let total = 0

      equipes
        .filter((item) => item.componente !== 'CVAT')
        .forEach((item) => {
          const regra = this.regras.qualidade.find((regra) => {
            return regra.label === getLabelRegra(item.equipe)
          })

          if (!regra) return

          const classificacaoEquipe = regra.classificacao.find((el) => {
            return el.tipo === classificacao
          })

          if (!classificacaoEquipe) return

          total += Number(item.quantidade || 0) * classificacaoEquipe.valor
        })

      return {
        text: '',
        total,
      }
    },

    formatarDadosDaTabelaPorcentagem() {
      let dataClassificacao = ['Ótimo', 'Bom', 'Suficiente', 'Regular']
      let data = []
      for (let index = 0; index < dataClassificacao.length; index++) {
        // classificação
        const classificacao = dataClassificacao[index]
        // vinculo e acompanhamento
        let vinculoAcompanhamento = 0
        let valorVinculoAcompanhamento = this.vinculo_e_acompanhamento.find(
          (item) => item.classificacao === classificacao
        )
        if (valorVinculoAcompanhamento) {
          vinculoAcompanhamento = valorVinculoAcompanhamento.valorTotal
        }
        // qualidade
        let qualidade = 0
        let valorQualidade = this.qualidade.find(
          (item) => item.classificacao === classificacao
        )
        if (valorQualidade) {
          qualidade = valorQualidade.valorTotal
        }
        // recebia
        let recebia = 0
        for (const key in this.dados.etapa6) {
          const element = this.dados.etapa6[key]
          recebia += element
        }
        // passa a receber
        const passaAreceber =
          // this.fixo.valorImplantacao +
          this.fixo.valorCusteio +
          vinculoAcompanhamento +
          qualidade +
          this.perCapitaTotal
        // aumentou
        let aumentou = passaAreceber - recebia
        // percentual
        const result = (aumentou / recebia) * 100
        const aumentouPercentual = result.toFixed(2)

        data.push({
          recebia: recebia,
          desempenho: classificacao,
          passaAreceber: passaAreceber,
          aumentou: passaAreceber - recebia,
          aumentouPercentual: aumentouPercentual,
        })
      }

      const otimo = data.find((el) => el.desempenho === 'Ótimo')
      const bom = data.find((el) => el.desempenho === 'Bom')
      const suficiente = data.find((el) => el.desempenho === 'Suficiente')
      const regular = data.find((el) => el.desempenho === 'Regular')
      const diferenca = otimo.passaAreceber - regular.passaAreceber
      this.diferencaMensalOtimoRegular = diferenca

      this.textoTabelaPorcentagem = `
        No cenário de pior desempenho, <b style="color: red">“REGULAR”</b>, o município recebe o valor
            de <b style="color: red">R$
            ${regular.passaAreceber.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
            })}</b>
            e no cenário de melhor desempenho, <b style="color: green">“ÓTIMO”</b>, o município recebe o
            valor de <b style="color: green">R$
            ${otimo.passaAreceber.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
            })}</b>. A diferença de <b style="color: ${
        diferenca < 0 ? 'red' : 'green'
      }"> R$
            ${diferenca.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
            })}</b> está
            relacionada aos componentes de vínculo e acompanhamento e qualidade
            que são os valores variáveis do cofinanciamento federal na APS.

      `
      this.texto2TabelaPorcentagem = `
        No Gráfico 5, pode-se observar que o valor de R$ ${diferenca.toLocaleString(
          'pt-BR',
          {
            minimumFractionDigits: 2,
          }
        )} representa o quanto o município <b>pode perder por mês</b> entre a classificação <b style='color: green'>“ÓTIMO”</b> e a classificação <b style='color: red'>“REGULAR”</b>.
      `

      this.dadosTabelaPorcentagem = data

      this.$refs.chartPorcentagem.updateSeries([
        {
          name: 'Desempenho',
          data: [
            otimo.passaAreceber,
            bom.passaAreceber,
            suficiente.passaAreceber,
            regular.passaAreceber,
          ],
        },
      ])

      const diferencaAnualEntreOtimoRegular =
        otimo.passaAreceber * 12 - regular.passaAreceber * 12
      this.diferencaAnualOtimoRegular = diferencaAnualEntreOtimoRegular
      this.texto3TabelaPorcentagem = `
        No Gráfico 6, pode-se observar que o valor de R$ ${diferencaAnualEntreOtimoRegular.toLocaleString(
          'pt-BR',
          {
            minimumFractionDigits: 2,
          }
        )} representa o quanto o município <b>pode perder por ano</b> entre a classificação <b style='color: green'>“ÓTIMO”</b> e a classificação <b style='color: red'>“REGULAR”</b>.
      `

      this.$refs.chartPorcentagemAnual.updateSeries([
        {
          name: 'Desempenho',
          data: [
            otimo.passaAreceber * 12,
            bom.passaAreceber * 12,
            suficiente.passaAreceber * 12,
            regular.passaAreceber * 12,
          ],
        },
      ])
    },

    async salvarSugestao() {
      try {
        this.loadingBtnSalvarSugestao = true
        const response = await this.$apiPublic.post(
          '/cofinanciamento-2024/sugestao',
          {
            ibge: this.dados.etapa1.cidade.co_ibge,
            email: this.dados.etapa2.email,
            sugestao: this.form.sugestao,
          }
        )
        if (response.data.error == false) {
          this.$toast.success(response.data.message, 'Sucesso:', {
            position: 'topCenter',
          })
        } else {
          this.$toast.error(response.data.message, 'Error:', {
            position: 'topCenter',
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.showModal = false
        this.loadingBtnSalvarSugestao = false
      }
    },

    imprimirPagina() {
      window.print()
    },

    voltar() {
      this.$emit('etapa-anterior')
    },

    proximo() {
      this.$refs.observer.validate().then((success) => {
        if (success) {
          this.imprimir()
        } else {
          this.$toast.warning('Preencha os campos obrigatórios!', 'Erro:', {
            position: 'topRight',
          })
        }
      })
    },
  },
}
</script>
<style scoped lang="scss" src="./styles.scss" />
<style>
.Etapa10 {
  height: auto !important;
}
</style>
<style lang="scss">
@media print {
  @page {
    margin: 8mm 15mm;
  }
}

#cofinanciamento-relatorio {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12pt;
  text-align: justify;
  counter-reset: page 0;
  @media print {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;

    * {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    .chartBar,
    .chartBar .apexcharts-canvas,
    .chartBar svg {
      width: 100% !important;
      max-width: 100% !important;
    }
  }

  .col-lg-6 {
    width: 50%;
  }

  .header {
    width: 800px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
    @media print {
      display: none;
    }
    @media screen and (max-width: 665px) {
      width: 100%;
    }
    button {
      height: auto;
    }
  }

  .page {
    position: relative;
    width: 210mm;
    min-height: 297mm;
    padding: 10mm;
    margin: 10mm auto;
    border: 1px #d3d3d3 solid;
    border-radius: 5px;
    background: white;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    counter-increment: page;

    @media screen and (max-width: 665px) {
      width: 100%;
      padding: 15px;
    }
    @media print {
      position: relative;
      padding: 0mm;
      margin: 0;
      border: initial;
      border-radius: initial;
      width: initial;
      min-height: initial;
      box-shadow: initial;
      background: initial;
      // page-break-after: always;
    }

    // &::before {
    //   content: counter(page);
    //   position: absolute;
    //   bottom: 10mm;
    //   right: 10mm;
    // }

    .title-1 {
      font-size: 14px;
      font-weight: 700;
      margin: 0;
      @media print {
        font-size: 22px;
        margin-top: 20px;
      }
    }

    .title-2 {
      font-size: 13pt;
      font-weight: 700;
      margin: 30px 0 0 0;
      text-transform: uppercase;
      color: #2e74b5;
      border-bottom: 1px solid #cecece;
      padding-bottom: 20px;
      &.text-left {
        margin-bottom: 15px;
      }
      @media print {
        font-size: 20px;
        margin-top: 30px;
      }
    }

    .title-3 {
      font-size: 12pt;
      font-weight: 700;
      text-align: center;
      margin: 0;
      color: #2e74b5;
      &.text-left {
        margin-bottom: 15px;
      }
      @media print {
        font-size: 18px;
        margin-top: 20px;
      }
    }

    .header-1 {
      display: flex;
      flex-direction: column;
      gap: 15px;
      .header-title-1 {
        font-size: 18pt;
        font-weight: bold;
        text-align: center;
        color: #1a3a5f;
      }

      .header-title-2 {
        font-size: 18pt;
        font-weight: bold;
        text-align: center;
        width: 500px;
        margin: 0 auto;
        color: #1a3a5f;
      }
    }

    .substract {
      h4 {
        font-size: 12pt;
        font-weight: 700;
        color: #2e74b5;
        border-bottom: 1px solid #cecece;
        padding-bottom: 20px;
        @media print {
        }
      }
    }

    .content-text {
      p {
        text-indent: 12mm;
      }
      .roman-list {
        list-style-type: none;
        margin: 0 12mm 5mm 12mm;

        ul {
          list-style: none;
          margin: 8px 0 0 18px;
          padding: 0;

          li {
            position: relative;
            margin-bottom: 6px;
            padding-left: 14px;
            line-height: 1.5;

            &::before {
              content: '•';
              position: absolute;
              left: 0;
              top: 0;
            }
          }
        }
      }
    }

    .container-table {
      @media print {
        margin-bottom: 15px;
      }
      @media screen and (max-width: 1024px) {
        overflow: scroll;
      }
      span {
        display: block;
        width: 100%;
        margin-bottom: 10px;
        font-size: 11pt;
        &.fonte {
          font-size: 9pt;
          font-style: italic;
        }
      }
      table {
        width: 100%;
        border: 1px solid;
        border-collapse: collapse;

        tr {
          &.grey {
            background: #f2f2f2;
          }
        }

        th {
          border: 1px solid black;
          text-align: center;
          background: #d9e1f2;
          font-size: 10pt;
          padding: 5px;
        }

        td {
          border: 1px solid black;
          padding: 10px;
          font-size: 10pt;
        }
      }
    }

    .page-break {
      page-break-before: always;
      counter-increment: page;
    }
  }

  .floating-buttons {
    position: fixed;
    left: 0;
    top: 50%;
    z-index: 999;
    @media print {
      display: none;
    }
    .menu-btn {
      background-color: #1178b3;
      padding: 15px;
      color: #fff;
      font-size: 20px;
    }
    ul {
      position: relative;
      top: 12px;
      li {
        padding: 15px;
        font-size: 14px;
        cursor: pointer;
        color: #fff;
        background-color: #1178b3;
        &:hover {
          background: rgba(0, 0, 0, 0.5);
          color: #fff;
        }
      }
    }
  }
}
.grafico-tabela-revisao {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<style>
#formObservacao button {
  float: right;
  width: auto;
}
</style>
